module.exports = __webpack_public_path__ + "static/media/luiz-profile.0aced8b9.png";